import React from 'react';
import { FieldIcon } from './NavIcons';

function TimeSlotPicker({ selectedTime, timeSlots, hasDate, isOpen, onToggle, onSelect, pickerRef, fieldId }) {
  const renderSlotItem = (slot, i, total) => (
    <div
      key={slot.value}
      onClick={() => onSelect(slot.value)}
      style={{
        padding: '14px 16px',
        fontSize: 14,
        cursor: 'pointer',
        textAlign: 'center',
        background: selectedTime === slot.value ? 'var(--primary-color)' : 'white',
        fontWeight: selectedTime === slot.value ? 600 : 400,
        borderBottom: i < total - 1 ? '1px solid #f0f0f0' : 'none',
        transition: 'background 0.15s'
      }}
    >
      {slot.label}
    </div>
  );

  const renderTwoColumns = () => {
    const half = Math.ceil(timeSlots.length / 2);
    const leftCol = timeSlots.slice(0, half);
    const rightCol = timeSlots.slice(half);
    return (
      <div style={{ display: 'flex' }}>
        <div style={{ flex: 1, borderRight: '1px solid #f0f0f0' }}>
          {leftCol.map((slot, i) => renderSlotItem(slot, i, leftCol.length))}
        </div>
        <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
          {rightCol.map((slot, i) => (
            <div
              key={slot.value}
              onClick={() => onSelect(slot.value)}
              style={{
                flex: 1, padding: '14px 16px',
                fontSize: 14,
                cursor: 'pointer',
                textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: selectedTime === slot.value ? 'var(--primary-color)' : 'white',
                fontWeight: selectedTime === slot.value ? 600 : 400,
                borderBottom: i < rightCol.length - 1 ? '1px solid #f0f0f0' : 'none',
                transition: 'background 0.15s'
              }}
            >
              {slot.label}
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="checkout-field" id={fieldId || "field-time"}>
      <label>Время доставки/самовывоза</label>
      <div
        className="checkout-date-picker"
        onClick={onToggle}
      >
        <span>{selectedTime || 'Выберите время'}</span>
        <span className="checkout-date-icon"><FieldIcon name="clock" /></span>
      </div>
      {isOpen && (
        <div ref={pickerRef} style={{
          marginTop: 8,
          background: 'white',
          border: '1px solid var(--border-color)',
          borderRadius: 12,
          overflow: 'hidden',
          boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
        }}>
          {timeSlots.length === 0 ? (
            <div style={{ padding: '14px 16px', fontSize: 14, color: '#999', textAlign: 'center' }}>
              {hasDate ? 'На сегодня все интервалы уже прошли' : 'Сначала выберите дату'}
            </div>
          ) : timeSlots.length <= 3 ? (
            <div>
              {timeSlots.map((slot, i) => renderSlotItem(slot, i, timeSlots.length))}
            </div>
          ) : renderTwoColumns()}
        </div>
      )}
    </div>
  );
}

export default TimeSlotPicker;
